module.exports = {
  SAVE_AGREEMENTS: 'SAVE_AGREEMENTS',
  RESET_AGREEMENTS: 'RESET_AGREEMENTS',
  SAVE_ACCEPTED_AGREEMENTS: 'SAVE_ACCEPTED_AGREEMENTS',
  RESET_AGREEMENT_FILTERS: 'RESET_AGREEMENT_FILTERS',
  SET_AGREEMENT_FILTER: 'SET_AGREEMENT_FILTER',
};